var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 78.409,
    viewBox: "0 0 73 78.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "React-icon",
    transform: "translate(11.5 12.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 6.295,
    cy: 6.295,
    r: 6.295,
    transform: "translate(18.705 20.597)",
    fill: "#61dafb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(-11 -11.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 36,
    cy: 12.896,
    rx: 36,
    ry: 12.896,
    transform: "translate(0 25.47)",
    fill: "none",
    stroke: "#61dafb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M36.374-.188c20.13,0,36.449,6.237,36.451,13.921S56.51,27.643,36.38,27.638-.069,21.4-.071,13.718,16.245-.192,36.374-.188Z",
    transform: "translate(29.698 0) rotate(60)",
    fill: "none",
    stroke: "#61dafb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M36.524.192c20.13,0,36.447,6.221,36.445,13.906S56.648,28.014,36.518,28.018.071,21.8.073,14.112,16.394.2,36.524.192Z",
    transform: "translate(66.476 13.79) rotate(120)",
    fill: "none",
    stroke: "#61dafb",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/react-icon.c19ce2f31fef9f470b587bf9580a1105.svg";
export { ForwardRef as ReactComponent };